import { useEffect } from "react";
import { emailTemplateService, taskService, userService } from "../../services";

export const useTaskAddData = (
  show: boolean,
  setAllUsers: (users: any[]) => void,
  setAllTaskTypes: (types: any[]) => void,
  setAdminEmail: (email: string) => void,
  setAllTaskTypesFull: (types: any[]) => void,
  setEmailTemplate: (t: any) => void,
  setTaskTemplate: (t: any) => void,
  setDataReady: (ready: boolean) => void
) => {
  useEffect(() => {
    if (!show) {
      setDataReady(false);
      return;
    }
    setDataReady(false);
    Promise.all([
      userService.getAllListItems(),
      taskService.getAllListTaskTypeItems(),
      userService.getAdminEmail(),
      taskService.getAllaskTypes()
    ]).then((response) => {
      setAllUsers(response[0]);
      setAllTaskTypes(response[1]);
      setAdminEmail(response[2]);
      setAllTaskTypesFull(response[3].results);
      setDataReady(true);
    });
  }, [show, setAllUsers, setAllTaskTypes, setAdminEmail, setAllTaskTypesFull, setDataReady]);

  useEffect(() => {
    if (!show) {
      return;
    }
    emailTemplateService.getAll().then(async (response) => {
      const taskCreationTemplate = response.find((template: any) => template.name === "Task creation");
      if (taskCreationTemplate) {
        const taskTemplateRow = await emailTemplateService.getById(taskCreationTemplate.id);
        setEmailTemplate(taskCreationTemplate);
        setTaskTemplate(taskTemplateRow);
      } else {
        console.error("Task Creation template not found");
      }
    });
  }, [show, setEmailTemplate, setTaskTemplate]);
};
